import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { AppConstants } from "src/app/constants/constants";
import { Location } from "@angular/common";
import { ScormCloseService } from "src/app/_services/scorm-close.service";
import { ComponentExitGuard } from "src/app/guards/component-exit.guard";
import { BaseComponent } from "../base/base-component.component";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-scorm-nav-close",
  templateUrl: "./scorm-nav-close.component.html",
  styleUrls: ["./scorm-nav-close.component.scss"],
})
export class ScormNavCloseComponent extends BaseComponent implements OnInit {
  readonly queryParams: string;
  prevPath: string;
  iframeData: any;
  fromLearningResources: boolean = false;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private scormCloseService: ScormCloseService,
    public componentExit: ComponentExitGuard,
    @Inject(LOCALE_ID) protected localeId: string  
    ) {
      super();
    }
  

  ngOnInit(): void {
    this.fromLearningResources = JSON.parse(
      this.route.snapshot.queryParamMap.get(AppConstants.FROM_LEARNING_RESOURCES)
    );
  }

  closeScorm() {

    this.checkScormResult();

    const lastQsetPanelState =
      this.location.getState()[AppConstants.SAVED_QSET_PANEL_STATE];
    this.scormCloseService.closeScorm(lastQsetPanelState);
  }

  checkScormResult() : void {
    this.prevPath = sessionStorage.getItem(AppConstants.PREV_PATH);
    let resultElement: HTMLElement = this.iframeData.querySelector(
      AppConstants.RESULT_ELEMENT
    );

    this.componentExit.isComplete = this.checkResultElement(resultElement);

    if(this.fromLearningResources){
      window.close();
    }
  }

  checkResultElement(resultElement: HTMLElement): boolean {
    return resultElement || resultElement != null ? true : false;
  }
}
